export default __webpack_public_path__ + "images/Q5.60ece09.png";